import { createSlice, configureStore } from "@reduxjs/toolkit";

const appSlice = createSlice(
    {name: 'store',
    initialState: {url: process.env.REACT_APP_API_URL, currentUser: null, emailVerified: false, transactions:[], days_left: null},
    reducers: {
        updateUser(state,action){
            state.currentUser = action.payload
        },
        updateTransactions(state,action){
            state.transactions = action.payload
        },
        updateAvailableBalance(state,action){
            state.availableBalance = action.payload
        },
        updateEmailVerified(state,action){
            state.emailVerified = action.payload
        },
        updateActiveRent(state,action){
            state.activeRent = action.payload
        },
      
        updateDaysLeft(state,action){
            state.days_left = action.payload
        }
 
    }

})

const store = configureStore({
    reducer:appSlice.reducer
})

export const actions = appSlice.actions
export default store